import Divider                from "_components/atoms/divider";
import Tabs                   from "_components/molecules/tabs";
import SearchResultsContainer from "_components/organisms/searchResultsContainer";

import useStyles      from "./styles";
import { formatTabs } from "./utils";

const component = props => {

	const { activeTab, changeTab, tabs, searchQuery, initialData } = props;
	const { classes }                                              = useStyles ( { tabsCount: tabs.length } );

	return (
		<div className = { classes.resultsParent }>

			<div className = { classes.tabsContainer }>
				<Tabs
					activeTab = { activeTab }
					list      = { formatTabs ( tabs ) }
					onChange  = { changeTab }
					variant   = "fullWidth"
				/>
			</div>

			<Divider style = { { width: "100%", maxWidth: "1000px" } } />

			<SearchResultsContainer
				activeTab           = { activeTab }
				changeTab           = { changeTab }
				initialData         = { initialData }
				searchQuery         = { searchQuery }
			/>
		</div>
	);
};

export default component;

